import cn from 'classnames';
import React, { useRef, useState } from 'react';
import { connect } from 'react-redux';
import { IMAGES } from 'src/appConfig/images';
import { PATHS } from 'src/appConfig/paths';
import ChangePassword from 'src/containers/ChangePassword';
import { authActions } from 'src/redux/authRedux';
import { IAppState } from 'src/store';
import { isEmpty } from 'src/validations';
import { Button, CustomDropdown, Image, NavLink, View } from '../common';
import './styles.scss';

const Navbar: React.FC<Props> = ({ showNavbar, user, isAuthenticated, collapseSidebar, onSignOut }) => {
  const [toggleNavbar, setToggleNavbar] = useState(false);
  const [openChangePasswordModal, setOpenModal] = useState(false);
  const navbarRef = useRef<HTMLElement>(null);

  if (!showNavbar) return null;

  // const getUserName = () => {
  //   if (!user?.firstName) return '';
  //   return `${user.firstName} ${user.lastName}`;
  // };

  // menu
  // const navbarItems = [
  //   {
  //     id: 'Dev',
  //     href: PATHS.Dev,
  //     label: 'Dev Components',
  //     renderIf: appConfig.NODE_ENV === 'development',
  //   },
  //   {
  //     id: 'UserName',
  //     label: getUserName(),
  //     renderIf: isAuthenticated,
  //   },
  //   {
  //     id: 'Log Out',
  //     label: 'Log Out',
  //     renderIf: isAuthenticated,
  //     onClick: () => {
  //       onSignOut(signOutSuccess, signOutError);
  //     },
  //   },
  //   {
  //     id: 'Log In',
  //     href: PATHS.SignIn,
  //     label: 'Log In',
  //     renderIf: !isAuthenticated,
  //   },
  // ];

  const signOutSuccess = () => {};

  const signOutError = () => {};

  return (
    <nav
      className={cn('cmp-navbar navbar jump-down', { 'is-collapse-sidebar': collapseSidebar })}
      ref={navbarRef}
      role="navigation"
      aria-label="main navigation">
      <View className="cmp-navbar__container">
        {openChangePasswordModal && (
          <ChangePassword
            onClose={() => {
              setOpenModal(false);
            }}
          />
        )}

        <View isRow flexGrow={1} className={cn('cmp-navbar__branch', 'navbar-brand')}>
          {collapseSidebar && (
            <NavLink className={cn('justify-center')} to={PATHS.Root}>
              <Image className={'cmp-navbar__logo'} src={IMAGES.logoFullText} />
            </NavLink>
          )}
          <button
            className={cn('cmp-navbar__burger navbar-burger burger', {
              'is-active': toggleNavbar,
            })}
            aria-label="menu"
            aria-expanded="false"
            data-target="lumisightTravel"
            onClick={() => setToggleNavbar(!toggleNavbar)}
            onKeyDown={() => setToggleNavbar(!toggleNavbar)}
            tabIndex={0}>
            <span aria-hidden="true" />
            <span aria-hidden="true" />
            <span aria-hidden="true" />
          </button>
        </View>

        <View
          renderIf={!isEmpty(isAuthenticated)}
          id="lumisightTravel"
          className={cn('navbar-menu', {
            'is-active': toggleNavbar === true,
          })}
          flexGrow={1}>
          <View isRow className={cn('navbar-end cmp-navbar__end is-hidden-touch')} flexGrow={1}>
            <View justify="center" flexGrow={1}>
              <CustomDropdown
                key={'Avatar In'}
                xPosition="left"
                label={'My Account'}
                items={[
                  {
                    icon: 'ic_lock',
                    label: 'Change Password',
                    onClick: () => {
                      setOpenModal(true);
                    },
                  },
                  {
                    icon: 'ic_logout',
                    label: 'Log Out',
                    onClick: () => {
                      onSignOut(signOutSuccess, signOutError);
                    },
                  },
                ]}
              />
            </View>
          </View>

          <View isRow className={cn('navbar-end cmp-navbar__end is-hidden-desktop')} flexGrow={1}>
            <Button
              key="Change Password"
              variant="link"
              label="Change Password"
              className={cn('cmp-navbar__end--button')}
              onClick={() => setOpenModal(true)}
            />
            <Button
              key="Log Out"
              variant="link"
              label="Log Out"
              className={cn('cmp-navbar__end--button')}
              onClick={() => onSignOut(signOutSuccess, signOutError)}
            />
          </View>
        </View>
      </View>
    </nav>
  );
};

type Props = ReturnType<typeof mapStateToProps> & typeof mapDispatchToProps;
const mapStateToProps = (state: IAppState) => ({
  showNavbar: state.common.showNavbar,
  collapseSidebar: state.common.collapseSidebar,
  user: state.auth.user,
  isAuthenticated: state.auth.isAuthenticated,
});

const mapDispatchToProps = {
  onSignOut: authActions.signOut,
};

export default connect(mapStateToProps, mapDispatchToProps)(Navbar);
